<template>
  <ion-page>
    <ion-content :fullscreen="true" :scroll-events="true">
      <div id="scroll-anchor" style="position:absolute; top:0; width:1px; height:1px;"></div>
      <div class="page-wrapper">
        <navbar />
        <hero-section />
        <about-section />
        <pillars-section />
        <programs-section />
        <values-section />
        <content-section />
        <impact-section />
        <stories-section />
        <world-map-section />
        <testimonials-section />
        <social-section />
        <resources-section />
        <partners-section />
        <donation-section />
        <volunteer-section />
        <newsletter-section />
        <footer-section />
        <WhatsAppFloat />
      </div>
    </ion-content>
  </ion-page>
</template>

<script setup>
import { IonPage, IonContent } from '@ionic/vue';
import { onMounted } from 'vue';
import Navbar from '@/components/sections/Navbar.vue';
import HeroSection from '@/components/sections/HeroSection.vue';
import AboutSection from '@/components/sections/AboutSection.vue';
import PillarsSection from '@/components/sections/PillarsSection.vue';
import ProgramsSection from '@/components/sections/ProgramsSection.vue';
import ValuesSection from '@/components/sections/ValuesSection.vue';
import ContentSection from '@/components/ContentSection.vue';
import ImpactSection from '@/components/sections/ImpactSection.vue';
import StoriesSection from '@/components/sections/StoriesSection.vue';
import WorldMapSection from '@/components/sections/WorldMapSection.vue';
import TestimonialsSection from '@/components/sections/TestimonialsSection.vue';
import SocialSection from '@/components/SocialSection.vue';
import ResourcesSection from '@/components/ResourcesSection.vue';
import PartnersSection from '@/components/PartnersSection.vue';
import DonationSection from '@/components/sections/DonationSection.vue';
import VolunteerSection from '@/components/sections/VolunteerSection.vue';
import NewsletterSection from '@/components/sections/NewsletterSection.vue';
import FooterSection from '@/components/sections/FooterSection.vue';
import WhatsAppFloat from '@/components/WhatsAppFloat.vue';
import { useScrollReveal } from '@/composables/useScrollReveal';

onMounted(() => {
  useScrollReveal();
});
</script>

<style scoped>
.page-wrapper {
  width: 100%;
  min-height: 100vh;
}
ion-content {
  --background: var(--vh-blanco);
  --padding-start: 0;
  --padding-end: 0;
  --padding-top: 0;
  --padding-bottom: 0;
}
</style>
